<template>
  <base-content>
    <template v-if="!pending" v-slot:top>
      <hero-header :heading="`${opportunity.title} Portfolio`">
        <template v-slot:right>
          <base-button class="mt-5" exact :to="{ name: 'opportunities' }">
            Back to Portfolio Opportunities
          </base-button>
        </template>
      </hero-header>
    </template>
    <template v-if="!pending">
      <div class="row">
        <div class="col-sm-6">
          <h5 class="font-weight-bold mb-4">{{ opportunity.title }} Portfolio</h5>
          <div v-html="opportunity.intro"></div>
        </div>
        <div class="col-sm-6">
          <base-card>
            <template v-slot:body-top>
              <base-card-title>Investment Calculator</base-card-title>
            </template>
            <base-field addon-left-icon="pound-sign" label="I want to invest:">
              <base-input v-model="amount" numeric placeholder="amount" />
            </base-field>
            <p>
              {{ opportunity.paymentSchedule === 'OnRedemption' ? 'On redemption' : 'Annual' }}
              rate of return: {{ opportunity.funding.interestRate }}%
            </p>
            <p>
              Value growth per year: {{ $formatting.toCurrency(annualInterest) }}
            </p>
            <p class="font-weight-bold">
              Ready to invest?
            </p>
            <p class="font-weight-bold">
              Please click to confirm you have read and accepted the terms and conditions and the risk warning.
            </p>
            <base-checkbox v-model="accepted.terms">
              I have read and accepted the terms of conditions
            </base-checkbox>
            <base-checkbox v-model="accepted.risk">
              I have read and accepted the risk warning
            </base-checkbox>
            <div class="d-flex align-items-center mt-3">
              <div>
                <base-button :disabled="disableInvestButton()" secondary @click="$modal.show('#InvestModal')">
                  Invest Now
                </base-button>
              </div>
              <div class="ml-2">
                Capital at risk
              </div>
            </div>
          </base-card>
        </div>
      </div>
      <invest-modal :base-amount.sync="amount" />
    </template>
    <template v-else>
      <base-loader />
    </template>
  </base-content>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import HeroHeader from '@/components/HeroHeader.vue'
import InvestModal from '@/components/InvestModal.vue'

export default {
  components: {
    HeroHeader,
    InvestModal
  },

  data: () => ({
    accepted: {
      terms: false,
      risk: false
    },
    amount: null,
    type: null
  }),

  created () {
    const { id, type } = this.$route.params

    this.type = type
    this.getOpportunity(id)
  },

  computed: {
    annualInterest () {
      if (this.amount) {
        return (this.opportunity.funding.interestRate / 100) * this.amount
      }

      return 0
    },

    ...mapState({
      opportunity: store => store.core.investments.opportunity,
      pending: store => store.core.investments.isOpportunityPending
    })
  },

  methods: {
    disableInvestButton () {
      const { terms, risk } = this.accepted

      return !terms || !risk
    },

    ...mapActions({
      getOpportunity: 'core/investments/opportunity'
    })
  }
}
</script>
